import type { FeatureEvents, ScreenEvent, TrackEvent, UIEvent } from '../new-analytics-types';
import { Action, ActionSubject, TrackAction, TrackActionSubject } from '../new-analytics-types';

export const organizationOverviewScreen = 'organizationOverviewScreen';

type ScreenKeys = 'organizationOverviewScreenEvent';

type UiKeys =
  | 'giveFeedbackButton'
  | 'quickActionButton'
  | 'giveFeedbackLink'
  | 'viewDomainsSuccessFlag'
  | 'refreshChartButton'
  | 'discoverCard';

export const orgOverviewEvents: FeatureEvents<ScreenKeys, UiKeys, string, string> = {
  confluenceSpec: 'https://hello.atlassian.net/wiki/spaces/CLOUDADMIN/pages/4063866580/Org+Overview+M1+Analytics',
  screen: {
    organizationOverviewScreenEvent: (): ScreenEvent => ({
      data: {
        name: organizationOverviewScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/71220',
    }),
  },
  ui: {
    giveFeedbackButton: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'giveFeedback',
        source: organizationOverviewScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/71223',
    }),
    giveFeedbackLink: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: 'giveFeedback',
        source: organizationOverviewScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/71325',
    }),
    quickActionButton: (attributes: { actionType: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'quickAction',
        source: organizationOverviewScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/72480',
    }),
    viewDomainsSuccessFlag: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: 'viewDomainsSuccessFlag',
        source: organizationOverviewScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/71225',
    }),
    refreshChartButton: (attributes: { reportId: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'refreshChart',
        source: organizationOverviewScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/71226',
    }),
    discoverCard: (attributes: { cardType: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Card,
        actionSubjectId: 'discoverCard',
        source: organizationOverviewScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/71227',
    }),
  },
  track: {
    featureExposed: (attributes: Record<string, unknown>): TrackEvent => ({
      data: {
        action: TrackAction.Exposed,
        actionSubject: TrackActionSubject.Feature,
        source: organizationOverviewScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/14797',
    }),
    showAvailableSeatsFeatureExposed: (attributes: Record<string, unknown>): TrackEvent => ({
      data: {
        action: TrackAction.Exposed,
        actionSubject: TrackActionSubject.ShowAvailableSeats,
        source: organizationOverviewScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/99672',
    }),
  },
  operational: {},
};
